import * as s from "react";
import T from "react";
import { j as Q, Q as g, d as E, R as U, k as $, t as k, S as b, w as q, K as X, M as Z } from "./CSSMotionList.js";
import { d as K } from "./warning.js";
import { createPortal as Y } from "react-dom";
const M = /* @__PURE__ */ T.createContext(void 0);
process.env.NODE_ENV !== "production" && (M.displayName = "zIndexContext");
const l = 100, G = 10, J = l * G, ee = J + l, z = {
  Modal: l,
  Drawer: l,
  Popover: l,
  Popconfirm: l,
  Tooltip: l,
  Tour: l,
  FloatButton: l
}, te = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function ne(e) {
  return e in z;
}
const Ee = (e, t) => {
  const [, n] = Q(), r = T.useContext(M), o = ne(e);
  let a;
  if (t !== void 0)
    a = [t, t];
  else {
    let i = r ?? 0;
    o ? i += // Use preset token zIndex by default but not stack when has parent container
    (r ? 0 : n.zIndexPopupBase) + // Container offset
    z[e] : i += te[e], a = [r === void 0 ? t : i, i];
  }
  if (process.env.NODE_ENV !== "production") {
    const i = K(e), d = n.zIndexPopupBase + ee, c = a[0] || 0;
    process.env.NODE_ENV !== "production" && i(t !== void 0 || c <= d, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return a;
}, ae = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), re = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Se = (e, t, n, r, o = !1) => {
  const a = o ? "&" : "";
  return {
    [`
      ${a}${e}-enter,
      ${a}${e}-appear
    `]: Object.assign(Object.assign({}, ae(r)), {
      animationPlayState: "paused"
    }),
    [`${a}${e}-leave`]: Object.assign(Object.assign({}, re(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${a}${e}-enter${e}-enter-active,
      ${a}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${a}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
};
var F = /* @__PURE__ */ s.createContext(null), O = [];
function oe(e, t) {
  var n = s.useState(function() {
    if (!g())
      return null;
    var u = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && u.setAttribute("data-debug", t), u;
  }), r = E(n, 1), o = r[0], a = s.useRef(!1), i = s.useContext(F), d = s.useState(O), c = E(d, 2), f = c[0], v = c[1], S = i || (a.current ? void 0 : function(u) {
    v(function(_) {
      var p = [u].concat(U(_));
      return p;
    });
  });
  function h() {
    o.parentElement || document.body.appendChild(o), a.current = !0;
  }
  function m() {
    var u;
    (u = o.parentElement) === null || u === void 0 || u.removeChild(o), a.current = !1;
  }
  return $(function() {
    return e ? i ? i(h) : h() : m(), m;
  }, [e]), $(function() {
    f.length && (f.forEach(function(u) {
      return u();
    }), v(O));
  }, [f]), [o, S];
}
var y;
function A(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var o, a;
  if (e) {
    var i = getComputedStyle(e);
    r.scrollbarColor = i.scrollbarColor, r.scrollbarWidth = i.scrollbarWidth;
    var d = getComputedStyle(e, "::-webkit-scrollbar"), c = parseInt(d.width, 10), f = parseInt(d.height, 10);
    try {
      var v = c ? "width: ".concat(d.width, ";") : "", S = f ? "height: ".concat(d.height, ";") : "";
      k(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(v, `
`).concat(S, `
}`), t);
    } catch (u) {
      console.error(u), o = c, a = f;
    }
  }
  document.body.appendChild(n);
  var h = e && o && !isNaN(o) ? o : n.offsetWidth - n.clientWidth, m = e && a && !isNaN(a) ? a : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), b(t), {
    width: h,
    height: m
  };
}
function ge(e) {
  return typeof document > "u" ? 0 : (y === void 0 && (y = A()), y.width);
}
function ie(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : A(e);
}
function ue() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var ce = "rc-util-locker-".concat(Date.now()), P = 0;
function se(e) {
  var t = !!e, n = s.useState(function() {
    return P += 1, "".concat(ce, "_").concat(P);
  }), r = E(n, 1), o = r[0];
  $(function() {
    if (t) {
      var a = ie(document.body).width, i = ue();
      k(`
html body {
  overflow-y: hidden;
  `.concat(i ? "width: calc(100% - ".concat(a, "px);") : "", `
}`), o);
    } else
      b(o);
    return function() {
      b(o);
    };
  }, [t, o]);
}
var de = !1;
function le(e) {
  return de;
}
var D = function(t) {
  return t === !1 ? !1 : !g() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, fe = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, a = e.debug, i = e.autoDestroy, d = i === void 0 ? !0 : i, c = e.children, f = s.useState(n), v = E(f, 2), S = v[0], h = v[1], m = S || n;
  process.env.NODE_ENV !== "production" && q(g() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), s.useEffect(function() {
    (d || n) && h(n);
  }, [n, d]);
  var u = s.useState(function() {
    return D(o);
  }), _ = E(u, 2), p = _[0], L = _[1];
  s.useEffect(function() {
    var R = D(o);
    L(R ?? null);
  });
  var W = oe(m && !p, a), I = E(W, 2), w = I[0], B = I[1], N = p ?? w;
  se(r && n && g() && (N === w || N === document.body));
  var x = null;
  if (c && X(c) && t) {
    var H = c;
    x = H.ref;
  }
  var V = Z(x, t);
  if (!m || !g() || p === void 0)
    return null;
  var j = N === !1 || le(), C = c;
  return t && (C = /* @__PURE__ */ s.cloneElement(c, {
    ref: V
  })), /* @__PURE__ */ s.createElement(F.Provider, {
    value: B
  }, j ? C : /* @__PURE__ */ Y(C, N));
});
process.env.NODE_ENV !== "production" && (fe.displayName = "Portal");
export {
  J as C,
  fe as P,
  ie as a,
  ge as g,
  Se as i,
  Ee as u,
  M as z
};
